"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import { getTenant } from "../../../../TENANT_CONFIGS";
var styled_components_1 = require("styled-components");
var PDFEmbedClass = /** @class */ (function () {
    function PDFEmbedClass(theme) {
        this.theme = theme;
        this.readyPromise = new Promise(function (resolve) {
            if (window.AdobeDC) {
                resolve();
            }
            else {
                /* Wait for Adobe Document Services PDF Embed API to be ready */
                document.addEventListener("adobe_dc_view_sdk.ready", function () {
                    resolve();
                });
            }
        });
        this.adobeDCView = undefined;
    }
    PDFEmbedClass.prototype.ready = function () {
        return this.readyPromise;
    };
    PDFEmbedClass.prototype.previewFile = function (divId, viewerConfig, fileInfo) {
        var _this = this;
        var config = {
            /* Pass your registered client id */
            clientId: window.location.href.includes('localhost')
                ? 'd12aa56c7f9a4b57af2cd65bb4250760' /** creds created for localhost on https://www.adobe.io/apis/documentcloud/dcsdk/gettingstarted.html# */
                : this.theme.adobeKey
            // process.env.REACT_APP_ENV === 'prod'
            //   ? process.env[`REACT_APP_ADOBE_EMBED_API_KEY__${this.theme?.getTenant()}`]
            //   : process.env.REACT_APP_ADOBE_EMBED_API_KEY //staging & dev
        };
        if (divId) {
            /* Optional only for Light Box embed mode */
            /* Pass the div id in which PDF should be rendered */
            config.divId = divId;
        }
        /* Initialize the AdobeDC View object */
        this.adobeDCView = new window.AdobeDC.View(config);
        /* Invoke the file preview API on Adobe DC View object */
        var previewFilePromise = function () { return _this.adobeDCView.previewFile({
            /* Pass information on how to access the file */
            content: {
                /* Location of file where it is hosted */
                location: {
                    url: fileInfo.path,
                },
            },
            /* Pass meta data of file */
            metaData: {
                /* file name */
                fileName: fileInfo.name,
            },
        }, viewerConfig); };
        return fileInfo.path && previewFilePromise();
    };
    return PDFEmbedClass;
}());
exports.default = PDFEmbedClass;
